import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Images } from '../../../@resources/img';
import { Flexer } from '../../dashboard/elements/LayoutElements';

const inOut = keyframes`
    0% {
        transform: translate(120%) scaleX(-1) rotate(20deg);
    }
    10% {
        transform: translate(60%) scaleX(-1) rotate(20deg);
    }
    90% {
        transform: translate(60%) scaleX(-1) rotate(20deg);
    }
    100% {
        transform: translate(120%) scaleX(-1) rotate(20deg);
    }
`;

const ImgFrame = styled.div`
    img {
        position: absolute;
        left: -12rem;
        top: 0;
        width: 12rem;
        max-width: initial;
        transform: translate(120%) scaleX(-1) rotate(20deg);
        animation: ${inOut} 1.25s ease-in-out;
    }
`;

export const ChickenEgg = () => {
    return <Flexer absolute right="0">
        <ImgFrame>
            <img src={Images.Chicken} />
        </ImgFrame>
    </Flexer>;
};
